/* eslint-disable max-len */
// Copyright (c) 2019 Deere & Company
import './index.scss';
import React, { Component } from 'react';
import {
    deleteUserContext, getAccessPrivileges, getBranch, getDefaultFactoryCode,
    getFactories, setDefaultFactoryCode, setUserContext,
} from '../../../app/common/repositories';
import Checkbox from '../../../shared/components/checkbox';
import MultiSelect from 'react-select';
import OptionsDropDown from '../../../shared/components/options-drop-down';

const roles = [{ roleId: '0', roleName: 'Super Administrator' },
    { roleId: '100', roleName: 'Administrator' },
    { roleId: '200', roleName: 'Editor' },
    { roleId: '300', roleName: 'General User' },
    { roleId: '301', roleName: 'Field User' },
];

class Preferences extends Component {


    state = {
        branches: [],
        factories: [],
        accessPrivileges: {},
        roleId: 0,
        roleSuperAdmin: false,
        roleAdmin: false,
        roleEditor: false,
        roleGeneralUser: false,
        roleFieldUser: false,
        roleAdminFactoryList: [],
        roleEditorFactoryList: [],
        roleGeneralUserFactoryList: [],
        roleFieldUserFactoryList: [],
        roleList: [],
        defaultFactoryCode: '',
        selectedFactoryCode: '',
    }

    componentWillMount = () => {

        getAccessPrivileges().then( response => {

            const roleobj = {};
            response.authorizedFactoryRoles.forEach( element => {

                if ( element.roldId !== 0 ) {

                    if ( !roleobj[element.roleId] ) roleobj[element.roleId] = [];
                    roleobj[element.roleId].push( element.unitCode );

                }

            } );

            const roleArray = [];
            Object.keys( roleobj ).forEach( key => {

                roleArray.push( {
                    roleId: key,
                    factoryCodes: roleobj[key],
                } );

            } );

            this.setState( {
                accessPrivileges: response,
                roleList: roleArray,
            } );
            this.updateFactoryCode( );
            this.updateBranches( );

        } );

    }

    getRoleName = id => {

        let role = '';
        roles.forEach( item => {

            if ( item.roleId === id ) role = item.roleName;

        } );

        return role;

    }

    updateFactoryCode = () => {

        getFactories().then( response => {

            const recFactories = [];
            response.forEach( factory => {

                recFactories.push( {
                    value: factory.factoryCode,
                    label: `${factory.factoryCode} - ${factory.factoryDescription}`,
                } );

            } );

            let defaultFactory = getDefaultFactoryCode();

            if ( defaultFactory === '' ) {

                let newDefaultFactory = '';

                // eslint-disable-next-line max-len
                if ( this.state.accessPrivileges && this.state.accessPrivileges.authorizedFactoryRoles.length > 0 ) {

                    // eslint-disable-next-line max-len
                    newDefaultFactory = this.state.accessPrivileges.authorizedFactoryRoles[0].unitCode;

                }

                if ( newDefaultFactory === '90' ) newDefaultFactory = '';

                if ( newDefaultFactory === '' && response.length > 0 ) newDefaultFactory = response[0].factoryCode;

                defaultFactory = newDefaultFactory;
                setDefaultFactoryCode( newDefaultFactory );

            }

            this.setState( {
                factories: recFactories,
                defaultFactoryCode: defaultFactory,
                selectedFactoryCode: defaultFactory,
            } );

        } );

    }

    updateBranches = () => {

        getBranch().then( response => {

            const recBranches = [];
            response.forEach( branch => {

                recBranches.push( {
                    value: branch.branchCode,
                    label: `${branch.branchCode} - ${branch.branchLocation}`,
                } );

            } );

            this.setState( { branches: recBranches } );

        } );

    }


    handleRoleChange = id => {

        this.setState( {
            roleId: id,
        } );


    }

    handleFactoryDropdownChange = id => {

        this.setState( {
            selectedFactoryCode: id,
        } );


    }

    updateFactory = ( source, selectedOption ) => {

        const FactoryArray = [];
        selectedOption.forEach( item => {

            FactoryArray.push( item.value );

        } );

        const srcFactorylist = `${source}FactoryList`;

        this.setState( {
            [srcFactorylist]: FactoryArray,
        } );

    };

    onDefaultFactorySubmit = ( ) => {

        if ( setDefaultFactoryCode( this.state.selectedFactoryCode ) ) {

            window.location.reload();

        }

    }

    handleCheckboxChange = value => {

        this.setState( {
            [value]: !this.state[value],
        } );

    }

    onDeleteContext = ( ) => {

        deleteUserContext( ).then( () => {

            window.location.reload();

        } ).catch( () => {

        } );

    }

    onSubmit = ( ) => {

        const payload = [];

        if ( this.state.roleSuperAdmin ) {

            payload.push( {
                roleId: '0',
                factoryCodeList: [],
            } );

        }

        if ( this.state.roleAdmin ) {

            payload.push( {
                roleId: '100',
                factoryCodeList: this.state.roleAdminFactoryList,
            } );

        }

        if ( this.state.roleEditor ) {

            payload.push( {
                roleId: '200',
                factoryCodeList: this.state.roleEditorFactoryList,
            } );

        }

        if ( this.state.roleGeneralUser ) {

            payload.push( {
                roleId: '300',
                factoryCodeList: this.state.roleGeneralUserFactoryList,
            } );

        }

        if ( this.state.roleFieldUser ) {

            payload.push( {
                roleId: '301',
                factoryCodeList: this.state.roleFieldUserFactoryList,
            } );

        }


        setUserContext( payload ).then( () => {

            let newDefaultFactory = this.state.defaultFactoryCode;
            if ( !this.state.roleSuperAdmin ) {

                const eligibleList = [];
                if ( this.state.roleAdmin ) this.state.roleAdminFactoryList.forEach( factory => eligibleList.push( factory ) );
                if ( this.state.roleEditor ) this.state.roleEditorFactoryList.forEach( factory => eligibleList.push( factory ) );
                if ( eligibleList.length && eligibleList.indexOf( newDefaultFactory ) === -1 ) {

                    // eslint-disable-next-line prefer-destructuring
                    newDefaultFactory = eligibleList[0];
                    setDefaultFactoryCode( newDefaultFactory );

                }

            }
            window.location.reload();

        } ).catch( () => {

        } );

    }


    render () {


        return (
            <section>
                <header>
                    <div>
                        <h2 className="page-header">My Preferences</h2>
                    </div>
                </header>
                <div className="sub-section">
                    <main>
                        <section>
                            <div className="rows half-row">
                                <label>Default Factory: </label>
                                <OptionsDropDown
                                    isPlaceholderTranslated={true}
                                    optionDisplayAttributes={['label']}
                                    optionKey="value"
                                    options={this.state.factories}
                                    onChange={this.handleFactoryDropdownChange}
                                    placeholder=""
                                    menuplacement="auto"
                                    selectedValue={this.state.selectedFactoryCode}
                                />
                            </div>
                            <button disabled={this.state.selectedFactoryCode === this.state.defaultFactoryCode} className="primary-button" onClick={this.onDefaultFactorySubmit} type="button"><span> Update Default Factory </span></button>
                        </section>
                    </main>
                    <main>
                        <section>
                            <div className="rows">
                                <label>User Role</label>
                                {this.state.accessPrivileges &&
                                    this.state.accessPrivileges.orginalSuperAdmin &&
                                        <span>Super Admin</span>}
                                {!this.state.accessPrivileges &&
                                    this.state.accessPrivileges.orginalSuperAdmin &&
                                        this.state.roleList.length > 0 &&
                                            <span>this.getRoleName(this.state.roleList[0])</span>}
                            </div>
                        </section>
                    </main>

                    {this.state.accessPrivileges.orginalSuperAdmin && (

                        <div className="sub-section">
                            <main>

                                <section>
                                    <div className="rows">
                                        <label>Current User Role & Context</label>

                                        <table cellSpacing="10">
                                            <tbody>
                                                <tr>
                                                    <th>Role</th>
                                                    <th>Unit Code</th>
                                                </tr>
                                                {this.state.roleList.map( key => (
                                                    <tr key={key.roleId}>

                                                        <td>{this.getRoleName( key.roleId )}</td>
                                                        {key.roleId !== '0' && (
                                                            // eslint-disable-next-line react/jsx-one-expression-per-line
                                                            <td> [{key.factoryCodes.join( ', ' )}]&nbsp;&nbsp; </td>
                                                        )}
                                                        {key.roleId === '0' && (
                                                            <td> Access To All Factories </td>
                                                        )}
                                                    </tr>
                                                ) )}
                                            </tbody>
                                        </table>
                                        <button className="primary-button" onClick={this.onDeleteContext} type="button"><span> Clear User Context </span></button>
                                    </div>
                                </section>

                            </main>
                        </div>
                    )}
                    {this.state.accessPrivileges.orginalSuperAdmin && (
                        <div className="sub-section">
                            <main>
                                <section className="sub-sec">
                                    <label>Modify Current User Role & Context</label>
                                    <div>
                                        <table className="roleTable" cellSpacing="10">
                                            <tbody>
                                                <tr>
                                                    <th className="role">Role</th>
                                                    <th className="unitcode">Unit Code</th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Checkbox
                                                            label="Super Adminstrator"
                                                            value="roleSuperAdmin"
                                                            handleCheckboxChange={this.handleCheckboxChange}
                                                            id="cboxSuperAdmin"
                                                            isChecked={this.state.roleSuperAdmin}
                                                        />
                                                    </td>
                                                    <td>All Factories</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Checkbox
                                                            label="Admin"
                                                            value="roleAdmin"
                                                            handleCheckboxChange={this.handleCheckboxChange}
                                                            id="cboxAdmin"
                                                            isChecked={this.state.roleAdmin}
                                                        />
                                                    </td>
                                                    <td>
                                                        <MultiSelect
                                                            isPlaceholderTranslated={true}
                                                            optionDisplayAttributes={['factoryDescription']}
                                                            optionKey="factoryCode"
                                                            options={this.state.factories}
                                                            onChange={this.updateFactory.bind( this, 'roleAdmin' )}
                                                            // value={this.state.searchInputs.authorizedFactoryRoles.unitCode}
                                                            isMulti="true"
                                                            menuPlacement="auto"
                                                            maxMenuHeight={280}
                                                            isDisabled={!this.state.roleAdmin}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Checkbox
                                                            label="Editor"
                                                            value="roleEditor"
                                                            handleCheckboxChange={this.handleCheckboxChange}
                                                            id="cboxEditor"
                                                            isChecked={this.state.roleEditor}
                                                        />
                                                    </td>
                                                    <td>
                                                        <MultiSelect
                                                            isPlaceholderTranslated={true}
                                                            optionDisplayAttributes={['factoryDescription']}
                                                            optionKey="factoryCode"
                                                            options={this.state.factories}
                                                            onChange={this.updateFactory.bind( this, 'roleEditor' )}
                                                            // value={this.state.searchInputs.authorizedFactoryRoles.unitCode}
                                                            isMulti="true"
                                                            menuPlacement="auto"
                                                            maxMenuHeight={280}
                                                            isDisabled={!this.state.roleEditor}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Checkbox
                                                            label="General User"
                                                            value="roleGeneralUser"
                                                            handleCheckboxChange={this.handleCheckboxChange}
                                                            id="cboxGeneralUser"
                                                            isChecked={this.state.roleGeneralUser}
                                                        />
                                                    </td>
                                                    <td>
                                                        <MultiSelect
                                                            isPlaceholderTranslated={true}
                                                            optionDisplayAttributes={['factoryDescription']}
                                                            optionKey="factoryCode"
                                                            options={this.state.factories}
                                                            onChange={this.updateFactory.bind( this, 'roleGeneralUser' )}
                                                            // value={this.state.searchInputs.authorizedFactoryRoles.unitCode}
                                                            isMulti="true"
                                                            menuPlacement="auto"
                                                            maxMenuHeight={280}
                                                            isDisabled={!this.state.roleGeneralUser}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Checkbox
                                                            label="Field User"
                                                            value="roleFieldUser"
                                                            handleCheckboxChange={this.handleCheckboxChange}
                                                            id="cboxFieldUser"
                                                            isChecked={this.state.roleFieldUser}
                                                        />
                                                    </td>
                                                    <td>
                                                        <MultiSelect
                                                            isPlaceholderTranslated={true}
                                                            optionDisplayAttributes={['branchLocation']}
                                                            optionKey="branchCode"
                                                            options={this.state.branches}
                                                            onChange={this.updateFactory.bind( this, 'roleFieldUser' )}
                                                            // value={this.state.searchInputs.authorizedFactoryRoles.unitCode}
                                                            isMulti="true"
                                                            menuPlacement="auto"
                                                            maxMenuHeight={280}
                                                            isDisabled={!this.state.roleFieldUser}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <button className="primary-button" onClick={this.onSubmit} type="button"><span> Submit </span></button>
                                </section>
                            </main>
                        </div>

                    )}

                </div>
            </section>
        );


    }

}


export default Preferences;
